import React, { useCallback, memo } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { viewEntityOnMap, setOverlapHoverEntity } from '@actions/map-actions';
import NewEntityListItem from '@shared/new-list-item/entity-list-item';

// eslint-disable-next-line no-unused-vars
const Entity = ({ id, entity_type, position, ...otherProps }) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(viewEntityOnMap(id, entity_type));
  }, [dispatch, id, entity_type]);

  const handleMouseEnter = useCallback(() => {
    const entity = { id, entity_type, ...otherProps };
    dispatch(setOverlapHoverEntity(entity));
  }, [dispatch, id, entity_type, otherProps]);

  const handleMouseLeave = useCallback(() => {
    dispatch(setOverlapHoverEntity());
  }, [dispatch]);

  // NewEntityListItem expects onClick to be called with (type, id, segments)
  // but we override it completely, so we pass a dummy onClick
  const dummyOnClick = useCallback(() => {}, []);

  return (
    <NewEntityListItem
      {...otherProps}
      id={id}
      entity_type={entity_type}
      onClick={dummyOnClick}
      customOnClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    />
  );
};

Entity.propTypes = {
  entity_type: PropTypes.string,
  id: PropTypes.number,
  position: PropTypes.object
};

export default memo(Entity);
